module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/5-48c2eb7820525b33da53447a40edee68.png";